import { render, staticRenderFns } from "./SScheme.vue?vue&type=template&id=0b1308a8"
import script from "./SScheme.vue?vue&type=script&lang=js"
export * from "./SScheme.vue?vue&type=script&lang=js"
import style0 from "./SScheme.vue?vue&type=style&index=0&id=0b1308a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports